// extracted by css-extract-rspack-plugin
module.exports =  {"template-16":"Template16-JW89__template-16","sentence-border":"Template16-DviO__sentence-border","sentence":"Template16-iq3M__sentence","options":"Template16-Ay0i__options"};